import angular from 'angular';
import configuration from './configuration/configuration.module';
import schoolCommonRoom from './school-common-room/school-common-room.module';
import settings from './settings/settings.module';
import dashboard from './dashboard/dashboard.module';
import happenings from './happenings/happenings.module';
import talks from './talks/talks.module';
import realizations from './realizations/realizations.module';
import attendances from './attendances/attendances.module';
import informations from './informations/informations.module';
import control from './control/control.module';
import summaries from './summaries/summaries.module';
import routes from './modules.routes';
import registerData from './register-data/register-data.module';

/**
 * @desc  Module initialize.
 *
 * @ngInject
 */
export default angular
  .module('app.modules', [
    configuration,
    schoolCommonRoom,
    settings,
    dashboard,
    realizations,
    attendances,
    happenings,
    talks,
    summaries,
    control,
    informations,
    registerData
  ])
  .config(routes)
  .name;
